import React from "react";
import axios from "axios";
import Costanti from "../../constantiX";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Column, InputText, Dialog, FileUpload, Toast, RadioButton } from "primereact";

import MultiLanguageDialog from "../MultiLanguageDialog";
import { initValue } from "../../util";

class ListaCaratteristiche extends React.Component {
  constructor() {
    super();
    this.actions = [
      {
        id: 1,
        icon: "pi-search",
        label: "",
        action: (id) => {
          this.vai(id, "V");
          console.log("View " + id);
        },
      },
    ];
    this.state = {
      activePage: 0,
      lista: [],
      totalRecords: 0,
      first: 0,
      rows: 10,
      loading: true,
      visible1: false,
      stato: "",
    };

    this.token = sessionStorage.getItem("ICEtoken");
    this.utente = JSON.parse(sessionStorage.getItem("utente"));
    this.state = {
      xcarica: "sezione",
      caratteristica: [],
      activePage: 1,
      totalRecords: 0,
      pageSize: 10,
      first: 0,
      visible2: false,
      visible3: false,
      singolo: {},
    };
    this.onPage = this.onPage.bind(this);
    this.prodottoid = 0;
  }

  showMessage(tipo, messageError, dettaglio) {
    var icona = "";
    if (tipo == "error") {
      icona = "pi pi-times-circle";
    }
    if (tipo == "info") {
      icona = "pipi-info-circle";
    }
    if (tipo == "success") {
      icona = "pi pi-check-circle";
    }
    if (tipo == "warning") {
      icona = "pi pi-exclamation-triangle";
    }
    this.toastBC.show({
      severity: tipo,
      life: 3000,
      closable: false,
      content: (
        <div className="flex flex-column" style={{ flex: "1" }}>
          <div className="text-center">
            <i className={icona} style={{ fontSize: "3rem" }}></i>
            <h4>{messageError}</h4>
            <h5>{dettaglio}</h5>
          </div>
        </div>
      ),
    });
  }

  componentDidMount() {
    this.prodottoid = this.props.prodottoid;
    this.caricaDati(1, this.state.pageSize);

    this.stato = this.props.stato;
    if (this.stato == "U") {
      this.actions.push(
        {
          id: 2,
          icon: "pi-pencil",
          label: "",
          action: (id) => {
            this.vai(id, "U");
            console.log("Update " + id);
          },
        },
        {
          id: 3,
          icon: "pi-trash",
          label: "",
          action: (id) => {
            this.vai(id, "D");
            console.log("Delete " + id);
          },
        },
      );
    }
  }

  async caricaDati(pagina, numrec) {
    try {
      let config = {
        headers: {
          Authorization: "Bearer " + this.token,
        },
      };
      this.setState({ loading: true });
      var quer = "page=" + pagina + "&num=" + numrec + "&prodottoid=" + this.prodottoid;
      const res = await axios.get(Costanti.UrlCallApi + "caratteristica/all?" + quer, config);
      res.data.lista1.forEach((element) => {
        element.azioni = this.actions;
      });
      const rowItemVal = [];
      const traduzioneArray = res.data.lista1.map((item) => item.traduzione);
      const caratteristicaIdArray = res.data.lista1.map((item) => item.id);
      traduzioneArray.forEach((el, index) => {
        const filteredValue = el.filter((item) => item.lingua === "it");
        const nome = filteredValue.find((item) => item.nomecampo === "nome");
        const descrizione = filteredValue.find((item) => item.nomecampo !== "nome");
        const fieldValue = {
          nome: nome ? nome.testo : "",
          descrizione: descrizione ? descrizione.testo : "",
          id: caratteristicaIdArray[index],
        };
        rowItemVal.push(fieldValue);
      });
      this.setState({
        caratteristica: rowItemVal.length > 0 ? rowItemVal : undefined,
        totalRecords: res.data.conta1,
        loading: false,
      });
    } catch (error) {
      console.error(error);
    }
  }

  caricaSingolo(id) {
    let config = {
      headers: {
        Authorization: "Bearer " + this.token,
      },
    };
    this.setState({ loading: true });
    axios
      .get(Costanti.UrlCallApi + "caratteristica/" + id, config)
      .then((res) => {
        this.setState({ singolo: res.data, loading: false });
        //alert(JSON.stringify(this.state.prodotti))
      })
      .catch((error) => {
        alert(error);
      });
  }

  setVisible1(val) {
    this.setState({ visible1: val });
    this.caricaDati(this.state.activePage, this.state.pageSize);
  }

  vai(id, tipo) {
    this.caricaSingolo(id);
    this.setVisible1(true);
    this.setState({ tipo: tipo });
    switch (tipo) {
      case "A":
        this.setState({ editMode: true, singolo: {}, intestazione: "Aggiungi Caratteristica" });
        break;
      case "V":
        this.setState({ intestazione: "Visualizza Caratteristica" });
        break;
      case "D":
        this.setState({ intestazione: "Elimina Caratteristica" });
        break;
      case "U":
        this.setState({ editMode: true, intestazione: "Modifica Caratteristica" });
        break;
    }
  }

  onPage(event) {
    this.setState({
      loading: true,
      activePage: event.page + 1,
      first: event.first,
    });
    this.caricaDati(event.page + 1, this.state.pageSize);
  }



  setPDF(value) {
    let config = {
      headers: {
        Authorization: "Bearer " + this.token,
      },
    };
    axios
      .get(Costanti.UrlCallApi + "stampe/caratteristiche/" + this.prodottoid, config)
      .then((res) => {
        const link = document.createElement("a");
        const url = Costanti.UrlCallApi + "file/getFile/" + res.data;

        link.href = url;
        link.setAttribute("download", res.data);
        // Append to html link element page
        document.body.appendChild(link);
        // Start download
        link.click();
        // Clean up and remove the link
        link.parentNode.removeChild(link);
      })
      .catch((error) => {
        this.showMessage("error", "Errore nella stampa", error.message);
        this.setState({ isSubmitting: false });
      });
  }


  render() {
    return (
      <div>
        <Toast ref={(el) => (this.toastBC = el)} position="bottom-center" />

        <Dialog
          header="PDF"
          closable={false}
          visible={this.state.viewPDF}
          modal
          breakpoints={{ "960px": "75vw", "640px": "100vw" }}
          style={{ width: "40vw" }}
          draggable={false}
          resizable={false}
        >
          <footer>
            <div className="border-top-1 surface-border pt-3">
              <Button type="button" icon="pi pi-check" onClick={() => this.setPDF(false)} label="Chiudi" />
            </div>
          </footer>
        </Dialog>
        <Dialog
          header="PDF"
          closable={false}
          visible={this.state.viewPDF}
          modal
          breakpoints={{ "960px": "75vw", "640px": "100vw" }}
          style={{ width: "40vw" }}
          draggable={false}
          resizable={false}
        >
          <footer>
            <div className="border-top-1 surface-border pt-3">
              <Button type="button" icon="pi pi-check" onClick={() => this.setPDF(false)} label="Chiudi" />
            </div>
          </footer>
        </Dialog>
        <DataTable
          value={this.state.caratteristica}
          emptyMessage={<div className="flex w-full justify-content-center font-bold ">NO DATA FOUND</div>}
          rows={this.state.pageSize}
          totalRecords={this.state.totalRecords}
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks CurrentPageReport NextPageLink LastPageLink"
          currentPageReportTemplate="	(pag. {currentPage} di {totalPages}) "
          paginator={true}
          onPage={this.onPage}
          loading={this.state.loading}
          lazy={true}
          first={this.state.first}
          header={
            <div className="mb-1 flex align-items-center justify-content-between">
              <span className="text-xl font-medium text-900">Lista Caratteristiche</span>
              <InputText type="search" className="border-none" placeholder="Cerca..." />
              {this.stato == "U" ? (
                <>
                  {/*<Button label="Esporta in Pdf" onClick={()=>this.setPDF(true)}   icon="pi pi-file-pdf" className="p-button-rounded p-button-danger "/> */}
                  {this.prodottoid > 0 && (
                    <Button
                      label="Aggiungi"
                      onClick={() => this.vai(0, "A")}
                      icon="pi pi-plus"
                      className="p-button-rounded p-button-primary "
                    />
                  )}
                </>
              ) : (
                ""
              )}
            </div>
          }
          responsiveLayout="stack"
        >
          <Column id="id1" field="nome" header="Nome" />
          <Column id="id2" field="descrizione" header="Valore" />

          <Column
            id="id5"
            field="id"
            header="Azioni"
            body={(item) => (
              <div className="product-list-action flex" style={{ alignItems: "center", gap: "1rem" }}>
                {this.actions.map((action) => (
                  <Button
                    key={action.id}
                    className="p-button-sm"
                    icon={`pi ${action.icon}`}
                    label={action.label}
                    aria-label={action.label}
                    onClick={(e) => {
                      e.stopPropagation();
                      action.action(item.id);
                    }}
                  />
                ))}
              </div>
            )}
          ></Column>
        </DataTable>

        {((this.state.singolo && Object.keys(this.state.singolo).length > 0) || this.state.tipo === "A") && (
          <MultiLanguageDialog
            title={this.state.intestazione}
            isVisible={this.state.visible1}
            operationType={this.state.tipo}
            itemId={this.state.singolo.id}
            contents={this.state.singolo}
            initValue={initValue}
            onClose={() => this.setVisible1(false)}
            label={["Nome", "Valore"]}
            itemToAdd={{
              datains: null,
              dataupd: null,
              id: 0,
              prodottoid: this.prodottoid,
              uteins: 1,
              uteupd: null,
              status: " ",
            }}
            table={"caratteristica"}
          />
        )}
      </div>
    );
  }
}

export default ListaCaratteristiche;
